import '../../../uri/URI.js';
import '../_misc.js';
import '../queryParams.js';
import '../cookies.js';
import '../userInfo.js';
import '../localStorage.js';
import './rfParam.js';
import { setSiteVisit } from './referredSiteVisit';

// See js/dc/general/README.md for notes about how this is used

$(() => {
    // This bundle can't sync visits to the server: it lacks submitFormToIframe and the CSRF
    // plumbing, and a failed sync's timeout handler wipes the localStorage queue.
    // TODO: I'm not aware of any time logReferredSiteVisit actually worked for third-party sites.
    // This setting doesn't ultimately fix any tracking problems, it just prevents us from running some
    // useless code that was certain to error in noisy ways.
    // If we want to be able to track referred visits to third-party sites in the future, we'll have to
    // update this further. We'd probably need to make it able to POST to our actual site
    setSiteVisit({ syncToServer: false });
});
